import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  GRAPH_PANEL_IMPORTS,
  GraphPanelComponent,
} from '../../../../panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-battery-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class BatteryGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.BatteryGraph;
  public override unit = DisplayUnit.Kwh;

  public override config: IGraphConfig = {
    sortOrder: [GraphType.BatteryLevel, GraphType.BatteryCharge, GraphType.BatteryDischarge],
    legendSortOrder: [GraphType.BatteryCharge, GraphType.BatteryDischarge, GraphType.BatteryLevel],
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.BatteryCharge:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Opladen', Color.Teal, DisplayUnit.Kwh, 'bar');
      case GraphType.BatteryDischarge:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Ontladen',
          Color.Purple,
          DisplayUnit.Kwh,
          'bar',
        );
      case GraphType.BatteryLevel:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          `Capaciteit (${DisplayUnit.Percentage})`,
          Color.LightGray,
          DisplayUnit.Percentage,
          'line',
        );
      case GraphType.BatteryPowerCharge:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Geladen', Color.Teal, DisplayUnit.Kw, 'line', {
          stack: undefined,
        });
      case GraphType.BatteryPowerDischarge:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Ontladen',
          Color.Purple,
          DisplayUnit.Kw,
          'line',
          {
            stack: undefined,
          },
        );
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
